export const groupServicesByType = (services = []) => {
  const grouped = services.reduce(
    (acc, service) => {
      const type = service?.workTypes?.type?.toLowerCase();
      if (type === "commercial") acc.commercial.push(service);
      else if (type === "residencial") acc.residential.push(service);
      return acc;
    },
    { commercial: [], residential: [] }
  );

  const sortByActiveThenName = (a, b) => {
    const aActive = a.companyServices?.[0]?.isActive ?? false;
    const bActive = b.companyServices?.[0]?.isActive ?? false;

    if (aActive !== bActive) return bActive ? 1 : -1;

    const aName = a.workServices?.name?.toLowerCase() || "";
    const bName = b.workServices?.name?.toLowerCase() || "";
    return aName.localeCompare(bName);
  };

  grouped.commercial.sort(sortByActiveThenName);
  grouped.residential.sort(sortByActiveThenName);

  return grouped;
};
